import { AnyAction, combineReducers, configureStore, ThunkDispatch } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import persistState from 'redux-localstorage'

import applicationCycle from './application-cycle'
import calendarVisitTypeFilters from './calendar-visit-type-filter'
import college from './college'
import currentSeniorYear from './current-senior-year'
import features from './feature-toggle'
import linkedCalendars from './linked-calendars'
import mapFilters from './map-filters'
import messaging from './messaging'
import metrics from './metrics'
import savedSearch from './saved-search'
import visitSelectedSchools from './selected-schools'
import snackbar from './snackbar'
import calendarUpcomingVisits from './upcoming-visits'
import user from './user'

const rootReducer = combineReducers({
  user,
  applicationCycle,
  college,
  currentSeniorYear,
  messaging,
  features,
  savedSearch,
  visitSelectedSchools,
  linkedCalendars,
  calendarUpcomingVisits,
  snackbar,
  mapFilters,
  calendarVisitTypeFilters,
  metrics,
})
const store = configureStore({
  reducer: rootReducer,
  enhancers: [
    persistState<RootState>(
      ['visitSelectedSchools', 'linkedCalendars', 'savedSearch', 'mapFilters', 'calendarVisitTypeFilters'],
      {
        key: 'scoir-admissions-redux-state',
      },
    ),
  ],
})

export type RootState = ReturnType<typeof rootReducer>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction>
export const useAppDispatch = () => useDispatch<AppDispatch>()

export default store
